(function () {

    angular
        .module('smartertoolsApp')
        .constant('moment', moment)
        .run([
            '$rootScope',
            function ($rootScope) {
                $rootScope.$on('$stateChangeSuccess', () => {
                    window.scrollTo(0, 0);
                    RecalculateAllFloatLabelControls();
                });
                $rootScope.$on('$routeChangeSuccess', (event, currentRoute, previousRoute) => {
                    window.scrollTo(0, 0);
                    RecalculateAllFloatLabelControls();
                });
            }
        ])
        .config([
            '$routeProvider',
            function ($routeProvider) {
                $routeProvider
                    .when('/', {
                        templateUrl: '/app/shopping-cart/cart.html',
                        controller: 'cartContentsController as cart'
                    })
                    .when('/add/:product', {
                        templateUrl: '/app/shopping-cart/add-product.html',
                        controller: 'cartAddProductController as cart'
                    })
                    .when('/modify-license', {
                        templateUrl: '/app/shopping-cart/modify-license.html',
                        controller: 'cartModifyLicenseController as cart'
                    })
                    .when('/renew-license', {
                        templateUrl: '/app/shopping-cart/modify-license.html',
                        controller: 'cartModifyLicenseController as cart'
                    })
                    .when('/ticket-details', {
                        templateUrl: '/app/shopping-cart/ticket-details.html',
                        controller: 'cartContentsController as cart'
                    })
                    .when('/checkout', {
                        templateUrl: '/app/shopping-cart/checkout.html',
                        controller: 'cartContentsController as cart'
                    })
                    .when('/installation-offer', {
                        templateUrl: '/app/shopping-cart/installation-offer.html',
                        controller: 'cartInstallationOfferController as cart'
                    })
                    .otherwise({redirectTo: '/'});
            }
        ]);

})();